module.exports = __webpack_public_path__ + "media/pokemon.f304a19f.webm";